/**
 * Notificaciones del panel.
 *
 * Se refrescan cada 5 minutos (mismo intervalo que la campana del panel anterior)
 * y al volver a la pestaña, para que un comprobante rechazado o un RIC atrasado
 * aparezcan sin recargar la página.
 */

import { useQuery } from '@tanstack/react-query';

import { apiClient } from '@/lib/http/api-client';

import type { ResumenNotificaciones } from './notificaciones.types';

/** Cada cuánto se vuelven a pedir los avisos. */
const INTERVALO_MS = 5 * 60 * 1000;

export const notificacionesKeys = {
  all: ['notificaciones'] as const,
};

/** Resumen de avisos del usuario (ya filtrado por sus grupos en el backend). */
export function useNotificaciones() {
  return useQuery({
    queryKey: notificacionesKeys.all,
    queryFn: ({ signal }) =>
      apiClient.get<ResumenNotificaciones>('/api/notificaciones', { signal }),
    staleTime: 60 * 1000,
    refetchInterval: INTERVALO_MS,
    refetchOnWindowFocus: true,
  });
}
